let currentUrl = window.location.href;
let url = '';
currentUrl = currentUrl.substring(currentUrl.indexOf("://") + 3);
url = currentUrl.substring(0, currentUrl.indexOf("/"));

export const API_URL = `https://${url}/veritas_api/public/api/tnkc-booking`

//change into veritas api
// export const API_URL = `https://222.127.23.109/veritas_api/public/api/tnkc-booking`;
